module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0133.jpg?v=2a9c64b9";